import { useAuth } from "@/hooks/use-auth";
import { toast } from "sonner";

export function useGoogleSignIn(next?: string) {
  const { supabase } = useAuth();

  async function signIn() {
    if (!supabase) return;
    const redirectTo = next
      ? `${window.location.origin}/auth/callback?next=${encodeURIComponent(next)}`
      : `${window.location.origin}/auth/callback`;
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo },
    });
    if (error) toast.error(error.message);
  }

  return { signIn, ready: !!supabase };
}
